import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HashRouter as BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import store from "./app/store/Store";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { loadThemeCss } from "./theme";
import LoadingScreen from "./app/components/loading/lmain";
import "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);


root.render(<LoadingScreen />);

loadThemeCss().then(() => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <ToastContainer autoClose={3000} hideProgressBar={true} />
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
  );
});

reportWebVitals();